import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader';
import Calling from '../api/Calling';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import MainButton from '../components/UI/MainButton';
import { MdPreview, MdDeleteOutline } from "react-icons/md";
import { GiClick } from "react-icons/gi";
import { formatView } from '../components/formatView';
import { ClickChart, ViewChart } from '../components/charts/ViewClickChart';
import generateCaptcha from '../components/captcha';

const ViewsDashbord = () => {
    const [loader, setLoader] = useState(false);
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [viewsData, setViewsData] = useState([]);
    const [clicksData, setClicksData] = useState([]);
    const [totalViews, setTotalViews] = useState(0);
    const [totalClicks, setTotalClicks] = useState(0);
    const [selectState, setSelectState] = useState('today');
    const { id } = useParams();
    const loaction = useLocation();

    const q = loaction?.search.split('=')[1] || null;
    const navigate = useNavigate();
    const fetchData = async () => {
        setLoader(true);
        try {
            const response = await Calling.adminViewsDashbord(id, startDate, endDate);
            if (response?.status) {
                setViewsData(response?.views_data);
                setClicksData(response?.clicks_data);
                setTotalClicks(response?.totalClicks || 0);
                setTotalViews(response?.totalViews || 0);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);

    const handleDateRangeFilter = (range) => {
        const today = new Date();
        let start, end;

        switch (range) {
            case 'today':
                start = today.toISOString().split('T')[0];
                end = start;
                setSelectState('today');
                break;
            case 'yesterday':
                const yesterday = new Date();
                yesterday.setDate(today.getDate() - 1);
                start = yesterday.toISOString().split('T')[0];
                end = start;
                setSelectState('yesterday');
                break;
            case 'thisWeek':
                const firstDayOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
                const lastDayOfWeek = new Date(firstDayOfWeek);
                lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
                start = firstDayOfWeek.toISOString().split('T')[0];
                end = lastDayOfWeek.toISOString().split('T')[0];
                setSelectState('thisWeek');
                break;
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1)
                    .toISOString()
                    .split('T')[0];
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    .toISOString()
                    .split('T')[0];
                setSelectState('thisMonth');
                break;
            case 'last6Months':
                start = new Date(today.getFullYear(), today.getMonth() - 5, 1)
                    .toISOString()
                    .split('T')[0];
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    .toISOString()
                    .split('T')[0];
                setSelectState('last6Months');
                break;
            case 'thisYear':
                start = new Date(today.getFullYear(), 0, 1).toISOString().split('T')[0];
                end = new Date(today.getFullYear(), 11, 31).toISOString().split('T')[0];
                setSelectState('thisYear');
                break;
            default:
                start = '';
                end = '';
        }

        setStartDate(start);
        setEndDate(end);
    };



    const handleFormDate = (e) => {
        if (e.target.name === "startDate") {
            setStartDate(e.target.value);
            setSelectState('range');
        } else {
            setEndDate(e.target.value);
            setSelectState('range');

        }
    }
    const clearData = async () => {
        const content = `You are about to clear data. To confirm, please solve this math problem.`;
        const isCaptchaValid = generateCaptcha(content);

        if (!isCaptchaValid) {
            return toast.error('Captcha answer is not correct', { autoClose: 2000 });
        }

        setLoader(true);
        try {
            let response = await Calling.deleteStoryBrandAnalytic(id, startDate, endDate);

            if (response?.status) {
                toast.success(response?.message);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoader(false);
            fetchData();
        }
    };

    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className="ml-[4.4rem] w-full text-main-font mt-16 px-3">
                    <h1 className="text-2xl font-bold mt-4 mb-2 text-main-font w-auto">View & Click Analytics
                    </h1>
                    <div className='bg-main-white rounded-xl'>
                        {/* Date Range Filters */}
                        <div className='grid grid-cols-12 items-center p-6'>
                            <div className="flex flex-wrap gap-2 justify-between col-span-8">
                                <div className='flex flex-wrap gap-4'>
                                    <MainButton onClick={() => handleDateRangeFilter('today')} label={'Today'} selectState={selectState === ('today')} />
                                    <MainButton onClick={() => handleDateRangeFilter('yesterday')} label={'Yesterday'} selectState={selectState === "yesterday"} />
                                    <MainButton onClick={() => handleDateRangeFilter('thisWeek')} label={'This Week'} selectState={selectState === ('thisWeek')} />
                                    <MainButton onClick={() => handleDateRangeFilter('thisMonth')} label={'This Month'} selectState={selectState === ('thisMonth')} />
                                    <MainButton onClick={() => handleDateRangeFilter('last6Months')} label={'Last 6 Months'} selectState={selectState === ('last6Months')} />
                                    <MainButton onClick={() => handleDateRangeFilter('thisYear')} label={'This Year'} selectState={selectState === ('thisYear')} />
                                </div>
                            </div>

                            <div className="grid grid-cols-12  gap-4 col-span-4">
                                <div className="flex gap-2 col-span-2"></div>
                                <input
                                    type="date"
                                    value={startDate}
                                    name='startDate'
                                    onChange={handleFormDate}
                                    className={`border cursor-pointer bg-main-white ${selectState === "range"
                                        ? 'border-main-blue text-main-blue'
                                        : 'border-main-border text-main-subfont'
                                        } px-4 py-2 rounded-lg focus:border-main-blue shadow-sm w-full md:w-auto col-span-5`}
                                />
                                <input
                                    type="date"
                                    value={endDate}
                                    name='endDate'
                                    onChange={handleFormDate}
                                    className={`border cursor-pointer bg-main-white ${selectState === "range"
                                        ? 'border-main-blue text-main-blue'
                                        : 'border-main-border text-main-subfont'
                                        } px-4 py-2 rounded-lg focus:border-main-blue shadow-sm w-full md:w-auto col-span-5`}
                                />

                            </div>
                        </div>

                        <hr className='border-main-border border-[1px]' />

                        {/* Card Section */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4 sm:p-6">
                            {/* Total View */}
                            <div className="flex flex-col break-words rounded-lg border-[1px] border-blue-600 bg-blue-100 text-main-white hover:shadow-lg transform transition-all duration-300 cursor-pointer">
                                <div className="flex justify-between items-center p-4">
                                    <div className='items-center'>
                                        <p className="text-sm capitalize text-main-subfont">Views</p>
                                        <h4 className="tracking-tighter text-xl text-main-font mt-[1px]">
                                            {totalViews < 10 ? '0' + totalViews : formatView(totalViews)}
                                        </h4>
                                    </div>
                                    <div className='text-main-white bg-blue-600 p-3 rounded-lg items-center'>
                                        <MdPreview size={30} />
                                    </div>
                                </div>
                            </div>

                            {/* Total Click */}
                            <div className="flex flex-col break-words rounded-lg border-[1px] border-purple-600 bg-purple-100 text-main-white hover:shadow-lg transform transition-all duration-300 cursor-pointer">
                                <div className="flex justify-between items-center  p-4">
                                    <div className='items-center'>
                                        <p className="text-sm capitalize text-main-subfont">Click</p>
                                        <h4 className="tracking-tighter text-xl text-main-font mt-[1px]">
                                            {totalClicks < 10 ? '0' + totalClicks : formatView(totalClicks)}
                                        </h4>
                                    </div>
                                    <div className='text-main-white bg-purple-600 p-3 rounded-lg items-center'>
                                        <GiClick size={30} />
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col cursor-pointer">
                                {q &&
                                    <div className='flex  justify-end'>
                                        <MainButton onClick={clearData} className='bg-main-delete text-white' label={<MdDeleteOutline />} />
                                    </div>
                                }
                            </div>
                        </div>

                        {/* Charts */}
                        <div className="p-4 sm:p-6 space-y-8">
                            {totalViews > 0 &&
                                <div className="h-64 sm:h-72 md:h-80 ">
                                    <ViewChart ViewData={viewsData} />
                                </div>
                            }
                            {
                                totalClicks > 0 &&
                                <div className="h-64 sm:h-72 md:h-80 ">
                                    <ClickChart ClickData={clicksData} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            )
            }
        </>
    )
}

export default ViewsDashbord